"use strict";

exports.__esModule = true;
exports.AlertsAnalysisScreen = void 0;
var _Core = require("../../Core");
var _react = _interopRequireDefault(require("react"));
var _Device = require("../../Device");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _App = require("../../App");
var _Report = require("../../Report");
var _AlertScreenToolbar = require("../AlertScreenToolbar");
var _AlertsAnalysisContainer = require("./AlertsAnalysisContainer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "AlertsAnalysisScreen__Container",
  componentId: "sc-2sa84k-0"
})(["display:flex;flex-direction:column;height:100vh;width:100%;overflow:hidden;overflow-y:auto;"]);
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "AlertsAnalysisScreen__Wrapper",
  componentId: "sc-2sa84k-1"
})(["overflow:hidden;overflow-y:auto;"]);
var AlertsAnalysisScreen = exports.AlertsAnalysisScreen = function AlertsAnalysisScreen() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var devices = _react["default"].useContext(_Device.DeviceListContext);
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("AlertsAnalysisScreen.title", "Alerts Analysis")
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    "data-testid": "AlertsAnalysisScreen.container"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("AlertsAnalysisScreen.navbar.title", "Alerts Analysis")
  }), /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(_Report.StandardReportDataProvider, {
    timeRangeKind: "multiDay"
  }, /*#__PURE__*/_react["default"].createElement(_AlertScreenToolbar.AlertScreenToolbar, {
    devices: devices,
    externalButtonGroupEnabled: false
  }), /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_Core.ComponentSize, null, function (_ref) {
    var width = _ref.width;
    return /*#__PURE__*/_react["default"].createElement(_AlertsAnalysisContainer.AlertsAnalysisContainer, {
      devices: devices,
      width: width - 50
    });
  })))))));
};